// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import letterAttachmentEntity from './entities/letter-attachment.json';
import letterAttachmentMenu from '../pages/letter-attachment/menu.json';
import letterAttachmentFullForm from '../pages/letter-attachment/forms/full.json';
import letterAttachmentContextForm from '../pages/letter-attachment/forms/context.json';
import letterAttachmentMiniForm from '../pages/letter-attachment/forms/mini.json';
import letterAttachmentLookupForm from '../pages/letter-attachment/forms/lookup.json';
import letterAttachmentTableView from '../pages/letter-attachment/views/table.json';
import letterAttachmentCardsView from '../pages/letter-attachment/views/cards.json';
import letterAttachmentCalendarView from '../pages/letter-attachment/views/calendar.json';
import letterAttachmentDashboardView from '../pages/letter-attachment/views/dashboard.json';

/** Тип запису «Вкладення» зі сторінками пакета: меню, форми та подання з pages/letter-attachment/. */
export const letterAttachmentDefinition: IRecordTypeDefinition = {
  ...letterAttachmentEntity,
  views: assembleViewSet({
      table: letterAttachmentTableView,
      cards: letterAttachmentCardsView,
      calendar: letterAttachmentCalendarView,
      dashboard: letterAttachmentDashboardView,
  }),
  form: letterAttachmentFullForm,
  forms: { full: letterAttachmentFullForm, context: letterAttachmentContextForm, mini: letterAttachmentMiniForm, lookup: letterAttachmentLookupForm },
  menu: letterAttachmentMenu,
} as IRecordTypeDefinition;
